const style = {
    centerContainer: {
        margin: ' 30px auto',
        width: {
            xs: '95%',
            md: '60%',
        },
    },

    questionContainer: {
        padding: '5px',
        borderRadius: '5px',
        backgroundColor: '#dcdcde',
        margin: '0px 0px 10px 0px',
    },

    questionText: {
        fontFamily: 'poppins',
        fontSize: '13px',
    },

    formLabelText: {
        fontFamily: 'poppins',
        fontSize: '13px',
    },

    radioColor: {
        color: '#ccc',
    },

    perQuestion: {
        margin: '0px 0px 15px 0px',
        padding: '5px',
    },
}
export default style
